import { styled } from '@mui/material'
import MainIMG_AdMain from 'src/assets/images/MainIMG_AdMain.svg'
import AdLoginBox from 'src/components/adminLogin/AdLoginBox'
import MainLogo from 'src/assets/images/Army_Link.svg'
import { useState } from 'react'
import { useAdLoginStore } from 'src/stores/AdLoginStore'
import AdFindIdBox from 'src/components/adminLogin/AdFindIdBox'
import AdFindPwBox from 'src/components/adminLogin/AdFindPwBox'
import AdModalBlocked from 'src/components/adminLogin/AdModalBlocked'
import { useCustomBackAction } from 'src/utils/useCustomBackAction'

const PageWrapper = styled('div')(({theme})=>({
  height: 'calc(100vh - 76px)',
  position:'relative'
}))

const BackgroundBox = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',

  height:'50%',
  backgroundColor : '#056D8B',
  overflow:'hidden',
  position:'relative'
}))

const BackgroundImg = styled('img')(({theme})=>({
  position:'absolute',
  bottom:'-50%',
  width:'115%'
}))

const FooterWrapper = styled('div')(({theme})=>({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',

  height:'90px',
  width:'100%',
  position:'absolute',
  bottom:0,
  zIndex:2,
  fontSize:'14px',
  color:'#7F7F7F',
  backgroundColor:'#DDDDDD'
}))

export type AdLoginTabType = 'Login' | 'FindId' | 'FindPw'

const AdLoginPage = () => {
  const tab = useAdLoginStore((state)=>state.tab)
  const setField = useAdLoginStore((state)=>state.setField)
  const [modal,setModal] = useState(false)

  useCustomBackAction(() => {
    // 뒤로가기 대신 이 액션을 실행함!
    setField('tab','Login')

  })

  return (
    <PageWrapper>
      <BackgroundBox>
        <BackgroundImg src={MainIMG_AdMain}/>
      </BackgroundBox>
      {tab === 'Login' && <AdLoginBox setModal={setModal}/>}
      {tab === 'FindId' && <AdFindIdBox/>}
      {tab === 'FindPw' && <AdFindPwBox/>}
      <FooterWrapper>
        <img src={MainLogo} style={{width:'247px',height:'auto'}}/>
        <span>본 사이트는 상업 목적상의 활용(링크)을 금지하고 있습니다.<br/>Copyright © 대한민국 육군 . All Right Reserved.</span>
      </FooterWrapper>
      <AdModalBlocked Open={modal} setState={setModal}/>
    </PageWrapper>
  )
}

export default AdLoginPage